import { theme as sparkTheme } from '@octane/spark'

import { BrandConfig, CustomTheme } from '../types'

// Spark's getCustomTheme only injects the Google Fonts <link> for `font` and
// `secondaryFont` values that are explicitly present on the theme config; it
// does not fetch the built-in default for the secondary family. Passing the
// Spark default through here keeps the token in sync and triggers the load.
const fallbackOctaneTheme: CustomTheme = {
    primary: '#005eb8',
    secondary: '#f3f8fe',
    background: '#f8f8fA',
    overlay: '#565b66',
    alternative: '#f3f8fe',
    spotlight: '#006adb',
    radius: 'rounded',
    font: 'Fira Sans',
    secondaryFont: sparkTheme.fonts.secondary,
}

const fallbackOctaneConfig: BrandConfig = {
    identifier: 'octaneFallback',
    name: 'Octane',
    navbarForceWhite: true,
    isDefault: false,
    sparkThemeId: 'octane',
    sparkThemeConfig: fallbackOctaneTheme,
    hideFooterAtLogin: true,
    hideNavbarAtLogin: false,
    loginTitle: 'Welcome Back!',
    navbarLogoUrl: `/img/logos/octane-dealer-platform.svg`,
    faviconUrl: `/img/favicons/favicon.ico`,
    pageTitle: 'Octane Dealer Portal',
}

export default fallbackOctaneConfig
